module.exports = __webpack_public_path__ + "static/media/twitcher.b138cfd6.png";